export enum PAYMENT_METHOD_MODE {
  EXISTING = 'existing',
  NEW = 'new',
}
